import React from 'react';
import {ArrowLeft, ArrowRight} from "react-feather";
import TableHeader from "../../../../components/Block/Table/TableHeader";
import TableBody from "../../../../components/Block/Table/TableBody";

function UpdateRequestsTable({headers, data, pagination, onChangePage}) {
    return (
        <table className="sl-table sl-width-100 sl-pb-32 sl-border-collapse sl-border-spacing-0">
            <TableHeader headers={headers}/>
            <TableBody data={data}/>
            {pagination.total_pages > 1 && (
                <tfoot>
                <tr className="sl-items-center sl-border-0 sl-border-b">
                    <td colSpan={6}>
                        <div
                            className="sl-flex sl-p-2 sl-justify-between sl-align-center sl-gap-3 sl-h-16 sl-border sl-border-solid sl-border-gray-200 sl-border-top-none sl-rounded-bottom-left-lg sl-rounded-bottom-right-lg sl-bg-white sl-shadow-md sl-pt-12 sl-pb-16 sl-px-24">
                            <button
                                onClick={() => onChangePage(pagination.current_page - 1)}
                                className="sl-flex sl-justify-center sl-align-center sl-gap-2 sl-h-11 sl-w-max-content sl-btn sl-btn-sm sl-btn-tertiary sl-shadow-xs sl-font sl-font-medium sl-text-md"
                                disabled={pagination.current_page === 1}>
                                <ArrowLeft size={20}/>
                                <span>Previous</span>
                            </button>

                            <span
                                className="sl-font sl-font-normal sl-text-sm sl-text-gray-700">Page <span
                                className="sl-font-medium">{pagination.current_page}</span> of <span
                                className="sl-font-medium">{pagination.total_pages}</span></span>

                            <button
                                onClick={() => onChangePage(pagination.current_page + 1)}
                                className="sl-flex sl-justify-center sl-align-center sl-gap-2 sl-h-11 sl-w-max-content sl-btn sl-btn-sm sl-btn-tertiary sl-shadow-xs sl-font sl-font-medium sl-text-md"
                                disabled={pagination.current_page === pagination.total_pages}>
                                <span>Next</span>
                                <ArrowRight size={20}/>
                            </button>
                        </div>
                    </td>
                </tr>
                </tfoot>
            )}
        </table>
    );
}

export default UpdateRequestsTable;
